import { Link } from 'react-router-dom';
import type { MediaItem } from '@/mocks/movies';

interface HotRankListProps {
  items: MediaItem[];
}

export default function HotRankList({ items }: HotRankListProps) {
  return (
    <ol className="flex flex-col gap-3">
      {items.map((item, i) => (
        <li key={item.id}>
          <Link
            to={`/detail/${item.id}`}
            className="group flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-200"
          >
            <span
              className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-md text-sm font-bold ${
                i < 3
                  ? 'bg-accent-500 text-background-50 dark:text-foreground-950'
                  : 'bg-secondary-100 text-secondary-800'
              }`}
            >
              {i + 1}
            </span>
            <span className="h-20 w-14 shrink-0 overflow-hidden rounded-md bg-background-200">
              <img
                src={item.cover}
                alt={`${item.title}海报`}
                title={`${item.title} 粉色水蜜桃影视`}
                className="h-full w-full object-cover object-top"
              />
            </span>
            <span className="min-w-0 flex-1">
              <span className="block line-clamp-1 text-sm font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
                {item.title}
              </span>
              <span className="mt-1 block line-clamp-1 text-xs text-foreground-600">
                {item.region} · {item.year} · {item.genres.slice(0, 2).join('/')}
              </span>
              <span className="mt-1.5 flex items-center gap-1 text-xs font-medium text-accent-700">
                <i className="ri-fire-line" aria-hidden="true"></i>
                热度 {item.heat}
              </span>
            </span>
          </Link>
        </li>
      ))}
    </ol>
  );
}